import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {BranchExtensionContainerModel} from '../../../../../../models/aggregates/branch';
import {Core2Config} from '../../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class BranchExtService extends BaseApiTemplateService<BranchExtensionContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches-exts';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches-exts';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches-exts';
    this.httpClient = http;
  }

}
